<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu :pageTitle="pageTitle" />

    <div class="card border-0 shadow-none rounded-1 mb-25">
      <div class="card-body p-xl-40">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <select
                v-model="filters.warehouse_id"
                class="form-select report-select h-55 shadow-none"
              >
                <option :value="null">{{ $t(`${i18nScope}.all_warehouses`) }}</option>
                <option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">
                  {{ warehouse.name }}
                </option>
              </select>

              <div class="year-switcher">
                <button
                  type="button"
                  class="btn btn-light h-55 px-3"
                  @click="changeYear(-1)"
                  :disabled="filters.year === 'lifetime'"
                  :aria-label="$t(`${i18nScope}.previous_year`)"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </button>

                <select
                  v-model="filters.year"
                  class="form-select report-select h-55 shadow-none"
                >
                  <option value="lifetime">{{ $t(`${i18nScope}.lifetime`) }}</option>
                  <option v-for="year in years" :key="year" :value="year">
                    {{ year }}
                  </option>
                </select>

                <button
                  type="button"
                  class="btn btn-light h-55 px-3"
                  @click="changeYear(1)"
                  :disabled="filters.year === 'lifetime' || Number(filters.year) >= currentYear"
                  :aria-label="$t(`${i18nScope}.next_year`)"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="d-flex justify-content-lg-end">
              <button
                type="button"
                class="btn style-three d-inline-flex align-items-center h-55 px-4"
                :disabled="exporting"
                @click="exportProfitLoss"
              >
                <i class="ri-file-excel-2-line me-1"></i>
                {{ exporting ? $t(`${i18nScope}.exporting`) : $t(`${i18nScope}.excel`) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProfitLoss
      :rows="rows"
      :loading="loading"
      :summary="summary"
      :includes-income="includesIncome"
      :i18n-scope="i18nScope"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import ProfitLoss from "../../components/Reports/ProfitLoss/ProfitLoss.vue";
import { useProfitLossReport } from "../../composables/useProfitLossReport";

export default defineComponent({
  name: "ProfitLossPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    ProfitLoss,
    MainFooter,
  },
  setup() {
    return useProfitLossReport();
  },
});
</script>

<style scoped>
.report-select {
  min-width: 220px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  color: #1f2940;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.report-select:focus {
  border-color: #5d5fef;
  box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12);
}

.year-switcher {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
